import React from 'react';
import {Link, hashHistory} from 'react-router';
import { connect } from 'react-redux'
import '../login.css';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import Header from '../Components/Header/HeaderUnauthorized';
import { resetPassword, identifyUser, sendPasswordChangeEmail }  from '../actions/authActions';
import { fireInAppBrowserPlugin } from '../actions/environmentActions';



const styleButton = {
    border: '1px solid #FFF', 
    color:"#fff", 
    padding:10, 
    textDecoration: 'none', 
    textAlign:'center', 
    display:'block', 
    fontSize: '20px',
    width:'90%',
    margin: '0 auto'
};


class ForgotLoginPage extends React.Component {

    contactSupport = () => {
        hashHistory.push("/go/support");
      }

 
  render() {

    return (
        <div>
            <Header>
                <span className="white">Unable to Login</span>
            </Header>
            
            <div className="container" style={{textAlign:'center'}} >
                <br />
                <br />
                <p className="white treuno" >Select the option that best fits your needs</p>
                <br />
                <Link style={styleButton}  to="/go/resetpassword" >RESET PASSWORD</Link>
                <br />
                <br />
                <a style={styleButton}  onClick={()=>{fireInAppBrowserPlugin("mailto:support@medefy.com?Subject=Cant%20verify%20account")}} >CAN'T VERIFY ACCOUNT</a>
                <br />
                <br />
                <a style={styleButton}  onClick={()=>{fireInAppBrowserPlugin("mailto:support@medefy.com?Subject=General%20support")}} >CONTACT SUPPORT</a>
                {/* <a style={styleButton}  onClick={this.contactSupport} >CONTACT SUPPORT</a> */}
            </div>
        </div>
               
    );
  }

};

export default ForgotLoginPage;




// WEBPACK FOOTER //
// ./src/Pages/ForgotLogin.js